import React from 'react';
import { Box } from '@apia/theme';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';
import useContext from '../../../../hooks/useContext';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import MakeField from '../fieldsStore/MakeField';
import FieldContext from '../fieldsStore/FieldContext';
import { IApiaInput } from '../../../../types';
import IProperty from '../../../../JSApi/constants/IProperty';
import { SimpleButton } from '../../../common';
import { ISimpleButton } from '../../../common/buttons/SimpleButton';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import { useApiaFormContext } from '../page/ApiaForm';

const ApiaButton = MakeField(
  React.forwardRef((_, ref) => {
    const { fireEvent } = useContext(FieldContext);

    const { field, fieldId } = useContext(ApiaComponentContextPrimitive);
    const props = usePropsSelector(fieldId);

    const {
      properties: { name },
    } = field as IApiaInput;

    const { identifier, isReadonly } = useApiaFieldCommonProps({
      className: 'button__field',
    });

    const { isFormReadOnly } = useApiaFormContext();

    const buttonProps = React.useMemo(
      () => ({
        'data-variant':
          (props.cssClass ?? '').indexOf('primary') !== -1
            ? 'buttons.primary'
            : 'buttons.outline',
        sx: {
          variant:
            (props.cssClass ?? '').indexOf('primary') !== -1
              ? 'buttons.primary'
              : 'buttons.outline',
          display: props[IProperty.PROPERTY_VISIBILITY_HIDDEN]
            ? 'none'
            : 'block',
          ...(props[IProperty.PROPERTY_FONT_COLOR] !== undefined
            ? { color: props[IProperty.PROPERTY_FONT_COLOR] }
            : null),
          width: props[IProperty.PROPERTY_SIZE]
            ? `${props[IProperty.PROPERTY_SIZE] ?? '150'}px `
            : undefined,
        },
        ref,
        type: 'button',
        name,
        ...identifier,
        disabled:
          isFormReadOnly ||
          props[IProperty.PROPERTY_DISABLED] ||
          props[IProperty.PROPERTY_INPUT_AS_TEXT] ||
          isReadonly,
        title:
          props[IProperty.PROPERTY_TITLE] ||
          props[IProperty.PROPERTY_TOOLTIP] ||
          props.value,
        onClick: () => {
          if (isReadonly) return;
          fireEvent('onClick');
        },
        'aria-label': props[IProperty.PROPERTY_ARIA_LABEL],
        'aria-description': props[IProperty.PROPERTY_ARIA_DESCRIPTION],
        autoFocus: props[IProperty.PROPERTY_AUTO_FOCUS],
      }),
      [isFormReadOnly, fireEvent, identifier, isReadonly, name, props, ref],
    );

    return (
      <>
        {!props.onGrid && !props.attributes.onGrid && (
          <Box as="span" className="spacer">
            &nbsp;
          </Box>
        )}
        <SimpleButton {...(buttonProps as unknown as ISimpleButton)}>
          {props.value as string}
        </SimpleButton>
      </>
    );
  }),
  {
    preSynchronize: () => true,
    doValidate: () => true,
    doSynchronize: () => true,
  },
);

export default ApiaButton;
